// ═══════════════════════════════════════════════════════════════════════════
// DISTIL PROTOCOL - SUPABASE CLIENT
// ═══════════════════════════════════════════════════════════════════════════

import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://xgxrluespwfzkxsatexx.supabase.co';
const SUPABASE_ANON_KEY = 'sb_publishable_Xfz8LGpuTswusxQmpza3sg_hbFQRbps';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

export default supabase;
